// NoSidebarLayout.js
import React from 'react';
import Aux from '../../Demo/hoc/_Aux';

const NoSidebarLayout = (props) => {
    return (
        <Aux>
            {props.children}
        </Aux>
    );
};

export default NoSidebarLayout;
